import {
  ITraderWallet,
  ITraderWalletTableColumns,
  TTraderWalletStatus,
} from '@entities/trades/wallet';
import { ITableActionsConfig, TableActionBtns } from '@features/table-action-btns';
import { FilterDateRange, FilterInput, FilterSelect } from '@features/table-filter';
import { getSelectOptions } from '@shared/components/Form';
import RequestStatusLabel from '@shared/components/RequestStatusLabel';

import { ChangeTraderWalletStatus } from '../components/ChangeTraderWalletStatus';
import { CreateTokenSale } from '../components/CreateTokenSale';
import { FreezeTraderWallet } from '../components/FreezeTraderWallet';

interface IProps {
  refetch?: () => void;
}

export const useTableSettings = ({ refetch }: IProps) => {
  const columnTitles: ITraderWalletTableColumns = {
    id: 'ID',
    trader_id: 'Trader ID',
    wallet_address: 'UPI ID',
    phone: 'Mobile',
    created_at: 'Created at',
    updated_at: 'Updated at',
    status: 'Status',
    bank: 'Bank',
    bank_code: 'IFSC-code',
    account_number: 'Account number',
    account_name: 'Account name',
    balance: 'Balance',
    actions: 'Actions',
  };

  const filterStatuses: TTraderWalletStatus[] = [
    'verification',
    'live',
    'inactive',
    'closed',
    'cooling',
    'frozen',
  ];
  const renderFilterElement = (key: keyof ITraderWallet) => {
    switch (key) {
      case 'bank':
        return <FilterInput name={'bank_name'} />;

      case 'status':
        return <FilterSelect name={key} options={getSelectOptions(filterStatuses)} />;

      case 'created_at':
      case 'updated_at':
        return <FilterDateRange name={key} />;

      case 'actions':
        return null;

      default:
        return <FilterInput name={key} />;
    }
  };

  const renderRow = (key: keyof ITraderWalletTableColumns, wallet: ITraderWallet) => {
    switch (key) {
      case 'status':
        return <RequestStatusLabel status={String(wallet[key])} />;

      case 'bank':
        return wallet.bank?.name;

      case 'actions': {
        const actionBtnsConfig: ITableActionsConfig = {
          freeze: {
            isEnabled: true,
            isVisible: true,
            popupElem: <FreezeTraderWallet wallet={wallet} refetch={refetch} />,
            popupSize: 'sm',
            allowedRoles: ['admin', 'operator'],
          },
          edit: {
            isEnabled: true,
            isVisible: true,
            popupElem: <ChangeTraderWalletStatus wallet={wallet} refetch={refetch} />,
            popupSize: 'sm',
            allowedRoles: ['admin', 'operator'],
          },
          'create-token-sale': {
            isEnabled: ['live', 'cooling', 'frozen'].includes(wallet.status),
            isVisible: true,
            popupElem: <CreateTokenSale wallet={wallet} refetch={refetch} />,
            popupSize: 'md',
            allowedRoles: ['admin', 'operator'],
          },
        };

        return <TableActionBtns config={actionBtnsConfig} />;
      }

      default:
        return wallet[key];
    }
  };

  return {
    columnTitles,
    renderRow,
    renderFilterElement,
  };
};
